export default __webpack_public_path__ + "static/media/1.321caf30.jpg";